import { LifeBuoy, Sun, Moon } from "lucide-react";
import { NotificationBell } from "@/components/NotificationBell";
import { Icon, IconButton } from "@/components/ds";
import { useSupportStore } from "@/stores/support";
import { useThemeStore } from "@/stores/theme";

/**
 * Brand actions cluster in the sidebar header: notifications, help and theme
 * toggle. Rendered in both shells (and twice on desktop), so the Help button
 * only flips the store — `<SupportDialog />` is mounted once per shell.
 */
export function BrandActions() {
  const theme = useThemeStore((s) => s.theme);
  const toggleTheme = useThemeStore((s) => s.toggle);
  const openSupport = useSupportStore((s) => s.open);

  return (
    <div className="flex items-center gap-0.5">
      <NotificationBell />
      <IconButton
        icon={LifeBuoy}
        label="Help"
        onClick={openSupport}
        aria-haspopup="dialog"
      />
      <button
        type="button"
        className="iconbtn"
        onClick={toggleTheme}
        aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
        title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      >
        <Icon icon={theme === "dark" ? Sun : Moon} size={16} />
      </button>
    </div>
  );
}
